import { createSlice } from '@reduxjs/toolkit';

const projectInitialState = {
  projectName: '',
  selectedStates: [],
  selectedDistricts: [],
  selectedVillages: [],
  projectStatus: true,
  selectedClientId: '',
  selectedCrops: [],
  selectedCropVarieties: [],
};
const initialState = {
  open: false,
  modalType: 'Add',
  project: projectInitialState,
  searchTerm: '',
};

const projectStateSlice = createSlice({
  name: 'projectStateSlice',
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.open = action.payload.open;
      state.modalType = action.payload.modalType;
      if (action.payload.modalType === 'Add') {
        state.project = projectInitialState;
      }
    },
    closeModal: (state) => {
      state.open = false;
    },
    editProject: (state, action) => {
      const {
        districts,
        crops,
        crop_varieties,
        project_id,
        project_name,
        project_status,
        states,
        client_id,
        clientinfo,
      } = action.payload;
      let selectedClientId = '';
      if (Array.isArray(client_id) && client_id.length > 0) {
        selectedClientId = client_id[0].client_id;
      } else if (clientinfo?.length > 0) {
        selectedClientId = clientinfo[0].client_id;
      } else if (typeof client_id === 'string') {
        selectedClientId = client_id;
      }
      state.project = {
        projectName: project_name,
        selectedStates: states,
        selectedDistricts: districts,
        selectedVillages: [],
        projectStatus: project_status,
        selectedClientId,
        selectedCrops: crops,
        selectedCropVarieties: crop_varieties || [],
        project_id,
      };
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
  },
});
export const { openModal, closeModal, editProject, setSearchTerm } =
  projectStateSlice.actions;
export default projectStateSlice.reducer;

// {
//   "type": "projectStateSclice/editProject",
//   "payload": {
//       "project_id": "3b09f997-75d3-4f93-a8b2-3a94e2803731",
//       "project_name": "testing",
//       "project_status": true,
//       "created_date": "2024-12-17T03:17:36.669Z",
//       "last_updated_date": "2024-12-17T03:17:36.669Z",
//       "last_modified_by": "71b3d997-15dd-423d-b732-28189fda27cb",
//       "client_id": "d7afefc2-7550-461f-9bde-acca81b63989",
//       "unique_id": "Project_42",
//       "project_infestations": [
//           {
//               "infestation_id": "0a5b51ac-bcbf-42f3-b35a-1cfa389d8e86",
//               "infestation_name": "Fusarium Wilt",
//               "crop_id": "9c707a99-2839-4955-bed7-a03830121727",
//               "created_date": "2024-07-25T07:48:31.997582",
//               "last_updated_date": "2024-07-25T07:48:31.997582",
//               "last_modified_by": "49b9809b-c3a0-4b0b-9763-5c6e37073215",
//               "unique_id": "Infest_16",
//               "infestation_status": true
//           }
//       ],
//       "states": [
//           {
//               "state_id": 3,
//               "country_id": 1,
//               "state": "Gujarat",
//               "state_latitude": 22.41512976,
//               "state_longitude": 72.0376327
//           },
//           {
//               "state_id": 7,
//               "country_id": 1,
//               "state": "Uttarakhand",
//               "state_latitude": 30.08081871,
//               "state_longitude": 79.29790003
//           },
//           {
//               "state_id": 11,
//               "country_id": 1,
//               "state": "Jharkhand",
//               "state_latitude": 23.65905,
//               "state_longitude": 85.17073204
//           }
//       ],
//       "districts": [
//           {
//               "district_id": 17,
//               "country_id": 1,
//               "state_id": 3,
//               "district": "Dahod",
//               "district_latitude": 22.92138595,
//               "district_longitude": 74.13798256
//           },
//           {
//               "district_id": 157,
//               "country_id": 1,
//               "state_id": 7,
//               "district": "Pauri Garhwal",
//               "district_latitude": 29.84425178,
//               "district_longitude": 78.70957782
//           },
//           {
//               "district_id": 205,
//               "country_id": 1,
//               "state_id": 7,
//               "district": "Nainital",
//               "district_latitude": 29.29140402,
//               "district_longitude": 79.4192121
//           },
//           {
//               "district_id": 526,
//               "country_id": 1,
//               "state_id": 11,
//               "district": "Pakur",
//               "district_latitude": 24.534635,
//               "district_longitude": 87.59693941
//           }
//       ],
//       "crops": [
//           {
//               "crop_id": "72b9be04-7e7d-43dd-964c-874950f9f5aa",
//               "crop_name": "Grape",
//               "created_date": "2024-05-17T11:59:24.047512",
//               "last_updated_date": "2024-05-17T11:59:24.047512",
//               "last_modified_by": "49b9809b-c3a0-4b0b-9763-5c6e37073215",
//               "crop_unique_id": "c-7",
//               "crop_status": true
//           },
//           {
//               "crop_id": "b13bca11-3d3e-4e00-8ee1-f0b5221e0e93",
//               "crop_name": "Paddy",
//               "created_date": "2024-05-17T11:57:53.708784",
//               "last_updated_date": "2024-05-17T11:57:53.708784",
//               "last_modified_by": "49b9809b-c3a0-4b0b-9763-5c6e37073215",
//               "crop_unique_id": "c-1",
//               "crop_status": true
//           },
//           {
//               "crop_id": "ff0c1977-6461-4638-b23d-d620394e1540",
//               "crop_name": "Tomato",
//               "created_date": "2024-05-17T11:58:54.301931",
//               "last_updated_date": "2024-05-17T11:58:54.301931",
//               "last_modified_by": "49b9809b-c3a0-4b0b-9763-5c6e37073215",
//               "crop_unique_id": "c-4",
//               "crop_status": true
//           }
//       ],
//       "clientinfo": [
//           {
//               "client_id": "d7afefc2-7550-461f-9bde-acca81b63989",
//               "client_name": "testing ",
//               "client_phone": "1234567890",
//               "created_date": "2024-12-16T12:03:33.870765",
//               "last_updated_date": "2024-12-16T12:03:33.870765",
//               "last_modified_by": "71b3d997-15dd-423d-b732-28189fda27cb",
//               "client_logo": "",
//               "client_email": "growero@email.com",
//               "client_status": true,
//               "unq_client_id": "client_003"
//           }
//       ]
//   }
// }

// -------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// {
//   "project_id": "3b09f997-75d3-4f93-a8b2-3a94e2803731",
//   "project_name": "testing",
//   "project_status": true,
//   "created_date": "2024-12-17T03:17:36.669Z",
//   "last_updated_date": "2024-12-17T03:17:36.669Z",
//   "last_modified_by": "71b3d997-15dd-423d-b732-28189fda27cb",
//   "client_id": "d7afefc2-7550-461f-9bde-acca81b63989",
//   "unique_id": "Project_42",
//   "project_infestations": [
//       {
//           "infestation_id": "0a5b51ac-bcbf-42f3-b35a-1cfa389d8e86",
//           "infestation_name": "Fusarium Wilt",
//           "crop_id": "9c707a99-2839-4955-bed7-a03830121727",
//           "created_date": "2024-07-25T07:48:31.997582",
//           "last_updated_date": "2024-07-25T07:48:31.997582",
//           "last_modified_by": "49b9809b-c3a0-4b0b-9763-5c6e37073215",
//           "unique_id": "Infest_16",
//           "infestation_status": true
//       }
//   ],
//   "states": [
//       {
//           "state_id": 3,
//           "country_id": 1,
//           "state": "Gujarat",
//           "state_latitude": 22.41512976,
//           "state_longitude": 72.0376327
//       },
//       {
//           "state_id": 7,
//           "country_id": 1,
//           "state": "Uttarakhand",
//           "state_latitude": 30.08081871,
//           "state_longitude": 79.29790003
//       },
//       {
//           "state_id": 11,
//           "country_id": 1,
//           "state": "Jharkhand",
//           "state_latitude": 23.65905,
//           "state_longitude": 85.17073204
//       }
//   ],
//   "districts": [
//       {
//           "district_id": 17,
//           "country_id": 1,
//           "state_id": 3,
//           "district": "Dahod",
//           "district_latitude": 22.92138595,
//           "district_longitude": 74.13798256
//       },
//       {
//           "district_id": 157,
//           "country_id": 1,
//           "state_id": 7,
//           "district": "Pauri Garhwal",
//           "district_latitude": 29.84425178,
//           "district_longitude": 78.70957782
//       },
//       {
//           "district_id": 205,
//           "country_id": 1,
//           "state_id": 7,
//           "district": "Nainital",
//           "district_latitude": 29.29140402,
//           "district_longitude": 79.4192121
//       },
//       {
//           "district_id": 526,
//           "country_id": 1,
//           "state_id": 11,
//           "district": "Pakur",
//           "district_latitude": 24.534635,
//           "district_longitude": 87.59693941
//       }
//   ],
//   "crops": [
//       {
//           "crop_id": "72b9be04-7e7d-43dd-964c-874950f9f5aa",
//           "crop_name": "Grape",
//           "created_date": "2024-05-17T11:59:24.047512",
//           "last_updated_date": "2024-05-17T11:59:24.047512",
//           "last_modified_by": "49b9809b-c3a0-4b0b-9763-5c6e37073215",
//           "crop_unique_id": "c-7",
//           "crop_status": true
//       },
//       {
//           "crop_id": "b13bca11-3d3e-4e00-8ee1-f0b5221e0e93",
//           "crop_name": "Paddy",
//           "created_date": "2024-05-17T11:57:53.708784",
//           "last_updated_date": "2024-05-17T11:57:53.708784",
//           "last_modified_by": "49b9809b-c3a0-4b0b-9763-5c6e37073215",
//           "crop_unique_id": "c-1",
//           "crop_status": true
//       },
//       {
//           "crop_id": "ff0c1977-6461-4638-b23d-d620394e1540",
//           "crop_name": "Tomato",
//           "created_date": "2024-05-17T11:58:54.301931",
//           "last_updated_date": "2024-05-17T11:58:54.301931",
//           "last_modified_by": "49b9809b-c3a0-4b0b-9763-5c6e37073215",
//           "crop_unique_id": "c-4",
//           "crop_status": true
//       }
//   ],
//   "clientinfo": [
//       {
//           "client_id": "d7afefc2-7550-461f-9bde-acca81b63989",
//           "client_name": "testing ",
//           "client_phone": "1234567890",
//           "created_date": "2024-12-16T12:03:33.870765",
//           "last_updated_date": "2024-12-16T12:03:33.870765",
//           "last_modified_by": "71b3d997-15dd-423d-b732-28189fda27cb",
//           "client_logo": "",
//           "client_email": "growero@email.com",
//           "client_status": true,
//           "unq_client_id": "client_003"
//       }
//   ]
// }
